module.exports = __webpack_public_path__ + "img/警告.71a08462.png";